import { ElevesDashboardProf } from '../../../types/classe/maClasse';
import { TableData } from '../../../components/organisms/Table/TableData';
import { TableDataLineChallenge } from '../../../components/organisms/Table/TableData/TableDataLineChallenge';
import React from 'react';

interface ChallengeTabProps {
  eleves: ElevesDashboardProf[];
}

const tabLabels = [
  'Nom complet',
  'Challenge',
  'CA (hors port)',
  'Ventes totales',
  'Ventes pro',
  'Ventes additionnelles',
  'Quiz'
];

export const ChallengeTab = ({ eleves }: ChallengeTabProps) => {
  return (
    <TableData tabLabels={tabLabels}>
      {eleves
        .sort((a, b) => a.lastname.localeCompare(b.lastname))
        .map(eleve => (
          <TableDataLineChallenge key={eleve.id} eleve={eleve} />
        ))}
    </TableData>
  );
};
